import React from "react";
import { useSelector } from "react-redux";

const LicenseInfo = () => {
  const systemWideLicenseInfo = useSelector(
    (state) => state.userAdmin.licenseInfo?.systemWideLicenseInfo
  );
  return (
    <div className="license__content__info">
      <span className="license__content__info__title">License Information</span>
      <div>
        <span>Total License Count</span>
        <span>{systemWideLicenseInfo?.licenseCount}</span>
      </div>
      <div>
        <span>Total Licensed Users</span>
        <span>{systemWideLicenseInfo?.licensedUsers}</span>
      </div>
      <div>
        <span>Available Licenses</span>
        <span>{systemWideLicenseInfo?.unusedLicenses}</span>
      </div>
      <div>
        <span>Available Reserved Licenses</span>
        <span>{systemWideLicenseInfo?.unusedReservedLicenses}</span>
      </div>
      <div>
        <span>Licensed Users in Multiple Workspaces</span>
        <span>{systemWideLicenseInfo?.multiWorkspaceUsers}</span>
      </div>
      <div>
        <span>Expiry Date</span>
        <span>{systemWideLicenseInfo?.expiryDate}</span>
      </div>
    </div>
  );
};

export default LicenseInfo;
